var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockIcon2120 = function SvgLockIcon2120(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B1B4B5",
    d: "M15.217 13.636a.957.957 0 0 1-.957-.957V7.107A3.41 3.41 0 0 0 10.854 3.7a3.41 3.41 0 0 0-3.407 3.407v3.24a.957.957 0 0 1-1.914 0v-3.24a5.326 5.326 0 0 1 5.32-5.32 5.327 5.327 0 0 1 5.321 5.32v5.572a.957.957 0 0 1-.957.957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB636",
    d: "M16.676 19.432H5.03a1.97 1.97 0 0 1-1.968-1.969V10.73c0-1.087.881-1.969 1.968-1.969h11.646c1.088 0 1.969.882 1.969 1.969v6.733a1.97 1.97 0 0 1-1.969 1.969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD469",
    d: "M4.77 17.846h-.1a.56.56 0 0 1-.562-.563v-6.372c0-.311.252-.563.563-.563h.099c.31 0 .562.252.562.563v6.372c0 .31-.252.563-.562.563"
  })));
};
export default SvgLockIcon2120;